angular.module('Itao.IndicatorMap').controller('TextfieldModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';

  $scope.data = data;

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new bookmark
   * @param {object} link object consisting of title and category id
   */
  $scope.create = function (link) {
    $uibModalInstance.close(link);
  };

}]);
